import React, { useEffect, useState } from "react";
import Breadcrumbs from "../based/Breadcrumbs";
import { NOTIFY } from "../based/Constants";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import Textbox from "../based/inputs/Textbox";
import useFormValidate from "../hooks/useFormValidate";
import EMB_MachineModel from "../models/EMB_MachineModel";
import EmbroideryServices from "../based/services/EmbroideryServices";

function MachineDetail(props) {
    const routeId = +props.match.params.id;
    const [isBusy, setIsBusy] = useState(false);
    const [machineId, setMachineId] = useState(routeId);
    const [model, setModel] = useState(new EMB_MachineModel());
    const [needleBars, setNeedleBars] = useState([]);
    const [duplicateError, setDuplicateError] = useState("");
    const { addRef, isValid } = useFormValidate();

    useEffect(() => {
        if (routeId > 0) _getMachine(routeId);
    }, [routeId]);

    async function _getMachine(id) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.GetMachineById(id);
        if (!err && data) {
            setModel(data);
            setNeedleBars(data.needleBars || []);
        }
        setIsBusy(false);
    }

    function _handleAddNeedleBar() {
        let nextIndex = needleBars.length > 0 ? Math.max(...needleBars.map((x) => x.needleBarIndex)) + 1 : 1;
        setNeedleBars([...needleBars, { id: 0, machineId: machineId, needleBarIndex: nextIndex, threadColorCode: "", threadColorName: "", threadColorHex: "" }]);
    }

    function _handleRemoveNeedleBar(idx) {
        let dt = [...needleBars];
        dt.splice(idx, 1);
        setNeedleBars(dt);
    }

    function _handleChangeNeedleBar(idx, field, value) {
        let dt = [...needleBars];
        dt[idx][field] = value;
        setNeedleBars(dt);
    }

    function _handleDragStart(e, idx) {
        e.dataTransfer.setData("text/plain", idx);
    }

    function _handleDragOver(e) {
        e.preventDefault();
    }

    function _handleDrop(e, targetIdx) {
        e.preventDefault();
        let sourceIdx = +e.dataTransfer.getData("text/plain");
        if (sourceIdx === targetIdx) return;
        let dt = [...needleBars];
        let [moved] = dt.splice(sourceIdx, 1);
        dt.splice(targetIdx, 0, moved);
        dt.forEach((x, i) => (x.needleBarIndex = i + 1));
        setNeedleBars(dt);
    }

    async function _handleSave() {
        if (!isValid()) return;
        setDuplicateError("");
        setIsBusy(true);
        let machineModel = { ...model, needleBarCount: needleBars.length };
        let [errMachine, dataMachine] = await EmbroideryServices.CreateUpdateMachine(machineModel);
        if (errMachine || !dataMachine) {
            setIsBusy(false);
            setDuplicateError("Mã máy bị trùng");
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
            return;
        }
        let savedMachineId = dataMachine;
        let [errNeedle, dataNeedle] = await EmbroideryServices.SaveNeedleBars(savedMachineId, needleBars);
        setIsBusy(false);
        if (!errNeedle && dataNeedle) {
            setMachineId(savedMachineId);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            if (props.history) props.history.push("/embroidery-machine");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg="Đang tải dữ liệu..." />
            <Breadcrumbs currentPage={routeId > 0 ? "Chi tiết máy thêu" : "Thêm máy thêu"} parentPage="Config Máy thêu/Màu kim" hrefParent="/embroidery-machine" />
            <div className="card-box p-20" style={{ maxWidth: 1280, margin: "0 auto" }}>
                <div className="row">
                    <div className="col-6 form-group">
                        <label htmlFor="controllerModel" className="required">
                            Dòng máy
                        </label>
                        <Textbox id="controllerModel" name="controllerModel" required ref={addRef} className="form-control" onChanged={(name, value) => setModel({ ...model, controllerModel: value })} value={model.controllerModel} />
                    </div>
                    <div className="col-6 form-group">
                        <label htmlFor="name" className="required">
                            Mã máy
                        </label>
                        <Textbox id="name" name="name" required ref={addRef} className="form-control" onChanged={(name, value) => setModel({ ...model, name: value })} value={model.name} />
                        {duplicateError && <span className="text-danger">{duplicateError}</span>}
                    </div>
                    <div className="col-6 form-group">
                        <label htmlFor="colorCodeSetName">Bộ Mã Màu</label>
                        <Textbox id="colorCodeSetName" name="colorCodeSetName" className="form-control" onChanged={(name, value) => setModel({ ...model, colorCodeSetName: value })} value={model.colorCodeSetName} />
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr className="text-center">
                            <th style={{ width: 40 }}></th>
                            <th>Số thứ tự đầu kim</th>
                            <th>Mã màu</th>
                            <th>Mã màu Wilcom</th>
                            <th>Tên màu</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {needleBars && needleBars.length > 0 ? (
                            needleBars.map((item, idx) => {
                                return (
                                    <tr key={idx} onDragOver={_handleDragOver} onDrop={(e) => _handleDrop(e, idx)}>
                                        <td className="text-center" draggable style={{ cursor: "move", userSelect: "none" }} onDragStart={(e) => _handleDragStart(e, idx)}>
                                            <i className="fa fa-bars"></i>
                                        </td>
                                        <td className="text-center" style={{ width: 100 }}>
                                            {item.needleBarIndex}
                                        </td>
                                        <td style={{ width: 250 }}>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="color"
                                                    value={item.threadColorHex ? `#${item.threadColorHex}` : "#ffffff"}
                                                    onChange={(e) => _handleChangeNeedleBar(idx, "threadColorHex", e.target.value.replace("#", ""))}
                                                    style={{ width: 32, height: 32, padding: 0, border: "1px solid #ccc", borderRadius: 4, marginRight: 8, flexShrink: 0 }}
                                                />
                                                <input type="text" className="form-control" placeholder="FFFFFF" value={item.threadColorHex || ""} onChange={(e) => _handleChangeNeedleBar(idx, "threadColorHex", e.target.value)} />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <input type="text" className="form-control" value={item.threadColorCode || ""} onChange={(e) => _handleChangeNeedleBar(idx, "threadColorCode", e.target.value)} />
                                        </td>
                                        <td className="text-center">
                                            <input type="text" className="form-control" value={item.threadColorName || ""} onChange={(e) => _handleChangeNeedleBar(idx, "threadColorName", e.target.value)} />
                                        </td>
                                        <td className="text-center" style={{ width: 100 }}>
                                            <button className="btn btn-danger" onClick={() => _handleRemoveNeedleBar(idx)}>
                                                Xóa
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    Chưa có kim nào được gán
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="add-item" style={{ color: "#64C5B1", fontSize: 16, fontWeight: 600, cursor: "pointer" }} onClick={_handleAddNeedleBar}>
                    Thêm +
                </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
                <button
                    className="btn btn-secondary mr-2"
                    onClick={() => {
                        if (props.history) props.history.push("/embroidery-machine");
                    }}
                >
                    Hủy
                </button>
                <button className="btn btn-custom" onClick={_handleSave}>
                    Lưu
                </button>
            </div>
        </React.Fragment>
    );
}

export default MachineDetail;
